var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vbt-error-boundary',{attrs:{"error":_vm.$attrs.error,"no-content":!_vm.items.length}},[_c('vbt-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"show-paginator":""},scopedSlots:_vm._u([{key:"orderItemId",fn:function(ref){
var orderItemId = ref.item.orderItemId;
return [_vm._v(" "+_vm._s(orderItemId || '-')+" ")]}},{key:"created",fn:function(ref){
var created = ref.item.created;
return [_vm._v(" "+_vm._s(_vm.formatDate(created, { dateFormat: 'yyyy-MM-dd, hh:mm:ss.SSS a' }))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }